import { useMutation, useQuery, useQueryClient } from "react-query";
import { fetchData } from "../api/client";

export const useClientRelationships = (clientId) => {
  const queryClient = useQueryClient();

  const query = useQuery(
    ["client-relationships", clientId],
    () => fetchData(`/clients/${clientId}/relationships`, "GET"),
    {
      enabled: Boolean(clientId),
      staleTime: 10_000,
      refetchOnWindowFocus: false,
      select: (resp) => resp?.data || [],
    }
  );

  const createMutation = useMutation(
    (payload) => fetchData(`/clients/${clientId}/relationships`, "POST", payload),
    {
      onSuccess: () => queryClient.invalidateQueries(["client-relationships", clientId]),
    }
  );

  const deleteMutation = useMutation(
    (relationshipId) =>
      fetchData(`/clients/${clientId}/relationships/${relationshipId}`, "DELETE"),
    {
      onSuccess: () => queryClient.invalidateQueries(["client-relationships", clientId]),
    }
  );

  return { ...query, createMutation, deleteMutation };
};
